<script>
  import {media} from 'svelte-match-media'
  import ViewSource from '../components/ViewSource.svelte'
</script>

<div class="chart">
  <h4 class="title">Did my CTV campaign impact customer outcomes?</h4>

  <h4 class="chart-header">Conversion Rate by Network</h4>
  {#if $media.mobile}
    <svg class="chart1" width="344" height="278" viewBox="0 0 344 278" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g class="red">
        <rect x="126.999" y="94" width="40" height="126" transform="rotate(90 126.999 94)"/>
        <rect x="343.999" y="166" width="40" height="343" transform="rotate(90 343.999 166)"/>
        <rect x="241.999" y="22" width="40" height="240" transform="rotate(90 241.999 22)"/>
        <rect x="101.999" y="238" width="40" height="101" transform="rotate(90 101.999 238)"/>
      </g>
      <g class="white large">
        <text><tspan x="182.515" y="47.736">0.021%</tspan></text>
        <text><tspan x="71.1558" y="118.736">0.011%</tspan></text>
        <text><tspan x="282.233" y="191.736">0.029%</tspan></text>
        <text><tspan x="40.0308" y="263.736">0.007%</tspan></text>
      </g>
      <g class="white bold">
        <text><tspan x="2" y="14.304">Network A</tspan></text>
        <text><tspan x="2" y="86.304">Network B</tspan></text>
        <text><tspan x="2" y="158.304">Network C</tspan></text>
        <text><tspan x="2" y="230.304">Network D</tspan></text>
      </g>
    </svg>
  {:else}
    <svg width="596" height="278" viewBox="0 0 596 278" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g class="red">
        <path d="M207.008 94V134L0.733398 134L0.7334 94L207.008 94Z"/>
        <path d="M562.258 166V206L0.734497 206L0.734499 166L562.258 166Z"/>
        <path d="M393.274 22V62L0.371094 62L0.371095 22L393.274 22Z"/>
        <path d="M166.08 238V278L0.733887 278L0.733888 238L166.08 238Z"/>
      </g>
      <g class="white large">
        <text transform="translate(323.951 34)"><tspan x="0" y="13.736">0.021%</tspan></text>
        <text transform="translate(141.96 106)"><tspan x="0" y="13.736">0.011%</tspan></text>
        <text transform="translate(491.299 178)"><tspan x="0" y="13.736">0.029%</tspan></text>
        <text transform="translate(95.1215 250)"><tspan x="0" y="13.736">0.007%</tspan></text>
      </g>
      <g class="white bold">
        <text><tspan x="0" y="14.304">Network A</tspan></text>
        <text transform="translate(0 72)"><tspan x="0" y="14.304">Network B</tspan></text>
        <text transform="translate(0.5 144)"><tspan x="0" y="14.304">Network C</tspan></text>
        <text transform="translate(0.1 216)"><tspan x="0" y="14.304">Network D</tspan></text>
      </g>
    </svg>
    
  {/if}
    
  <h4 class="chart-header">Path to Conversion Analysis</h4>
  {#if $media.mobile}
    <svg class="chart2" width="345" height="136" viewBox="0 0 345 136" xmlns="http://www.w3.org/2000/svg">
      <path d="M297.174 96L307.999 116L297.174 136L189.999 136L189.999 96L297.174 96Z" class="gray"/>
      <path d="M195.174 48L205.999 68L195.174 88L87.9985 88L87.9985 48L195.174 48Z" class="gray"/>
      <path d="M195.174 96L205.999 116L195.174 136L87.9985 136L87.9985 96L195.174 96Z" class="gray-darker"/>
      <path d="M89.8547 1.02659e-05L102.999 20L89.8547 40L0.998533 40L0.998535 -4.45856e-06L89.8547 1.02659e-05Z" class="gray"/>
      <path d="M89.8547 48L100.999 68L89.8547 88L0.998533 88L0.998535 48L89.8547 48Z" class="red"/>
      <path d="M89.8547 96L100.999 116L89.8547 136L0.998533 136L0.998535 96L89.8547 96Z" class="red"/>
      <g class="white play-icon">
        <path d="M122.199 106.2C117.199 106.2 113.199 110.2 113.199 115.2C113.199 120.2 117.199 124.2 122.199 124.2C127.199 124.2 131.199 120.2 131.199 115.2C131.199 110.2 127.099 106.2 122.199 106.2ZM122.199 123C117.899 123 114.299 119.5 114.299 115.1C114.299 110.7 117.799 107.2 122.199 107.2C126.599 107.2 129.999 110.8 129.999 115.2C129.999 119.6 126.499 123 122.199 123Z"/>
        <path d="M119.299 110.3V120L127.699 115.1L119.299 110.3ZM120.499 112.2L125.599 115.1L120.499 118V112.2Z"/>
      </g>
      <g class="white">
        <text><tspan x="38.9985" y="25.069">Display</tspan></text>
        <text><tspan x="139.999" y="73.069">Display</tspan></text>
        <text><tspan x="243.999" y="121.069">Display</tspan></text>
        <text><tspan x="139.999" y="121.069">Video</tspan></text>
        <text><tspan x="11.9985" y="73.069">CTV</tspan></text>
        <text><tspan x="11.9985" y="121.069">CTV</tspan></text>
      </g>
      <g class="white larger">
        <text><tspan x="316" y="74.403">18x</tspan></text>
        <text><tspan x="313" y="122.403">28x</tspan></text>
      </g>
      <g class="white laptop">
        <path d="M27.9985 20.9V12H13.9985V20.9L11.9985 27H29.9985L27.9985 20.9ZM15.0985 13.1H26.8985V20.9H15.0985V13.1ZM14.7985 22H27.1985L28.3985 25.9H13.5985L14.7985 22Z"/>
        <path d="M18.3985 23.8L17.9985 25H23.9985L23.6985 23.8H18.3985Z"/>
      </g>
      <g class="white laptop">
        <path d="M128.999 68.9V60H114.999V68.9L112.999 75H130.999L128.999 68.9ZM116.099 61.1H127.899V68.9H116.099V61.1ZM115.799 70H128.199L129.399 73.9H114.599L115.799 70Z"/>
        <path d="M119.399 71.8L118.999 73H124.999L124.699 71.8H119.399Z"/>
      </g>
      <g class="white laptop">
        <path d="M232.999 116.9V108H218.999V116.9L216.999 123H234.999L232.999 116.9ZM220.099 109.1H231.899V116.9H220.099V109.1ZM219.799 118H232.199L233.399 121.9H218.599L219.799 118Z"/>
        <path d="M223.399 119.8L222.999 121H228.999L228.699 119.8H223.399Z"/>
      </g>
    </svg>
  {:else}
    <svg width="596" height="136" viewBox="0 0 596 136" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M529.226 96L542 116L529.226 136L338 136L338 96L529.226 96Z" class="gray"/>
      <path d="M347.226 48L360 68L347.226 88L156 88L156 48L347.226 48Z" class="gray"/>
      <path d="M347.226 96L360 116L347.226 136L156 136L156 96L347.226 96Z" class="gray-darker"/>
      <path d="M159.454 1.71949e-05L172 20L159.454 40L1 40L1 0L159.454 1.71949e-05Z" class="gray"/>
      <path d="M159.647 48L173 68L159.647 88L0.999878 88L0.99988 48L159.647 48Z" class="red"/>
      <path d="M159.647 96L173 116L159.647 136L0.999878 136L0.99988 96L159.647 96Z" class="red"/>
      <g class="white play-icon">
        <path d="M203.065 104.261C196.508 104.261 191.262 109.478 191.262 116C191.262 122.522 196.508 127.739 203.065 127.739C209.623 127.739 214.869 122.522 214.869 116C214.869 109.478 209.492 104.261 203.065 104.261ZM203.065 126.174C197.426 126.174 192.705 121.609 192.705 115.87C192.705 110.131 197.295 105.565 203.065 105.565C208.836 105.565 213.295 110.261 213.295 116C213.295 121.739 208.705 126.174 203.065 126.174Z" fill="white"/>
        <path d="M199.262 109.609V122.261L210.279 115.87L199.262 109.609ZM200.836 112.087L207.525 115.87L200.836 119.652V112.087Z" fill="white"/>
      </g>
      <g class="white laptop">
        <path d="M43.8888 22.403V8.55859H22.111V22.403L18.9999 31.8919H46.9999L43.8888 22.403ZM23.8221 10.2697H42.1777V22.403H23.8221V10.2697ZM23.3554 24.1141H42.6443L44.511 30.1808H21.4888L23.3554 24.1141Z" fill="white"/>
        <path d="M28.9533 26.9199L28.3311 28.7866H37.6644L37.1977 26.9199H28.9533Z" fill="white"/>
      </g>
      <g class="white laptop">
        <path d="M214.889 70.4001V56.5557H193.111V70.4001L190 79.889H218L214.889 70.4001ZM194.822 58.2668H213.178V70.4001H194.822V58.2668ZM194.355 72.1112H213.644L215.511 78.1779H192.489L194.355 72.1112Z" fill="white"/>
        <path d="M199.955 74.9111L199.333 76.7778H208.667L208.2 74.9111H199.955Z" fill="white"/>
      </g>
      <g class="white laptop">
        <path d="M402.889 118.4V104.556H381.111V118.4L378 127.889H406L402.889 118.4ZM382.822 106.267H401.178V118.4H382.822V106.267ZM382.355 120.111H401.644L403.511 126.178H380.489L382.355 120.111Z" fill="white"/>
        <path d="M387.955 122.911L387.333 124.778H396.667L396.2 122.911H387.955Z" fill="white"/>
      </g>
      <g class="white large">
        <text transform="translate(54.2987 12)"><tspan x="0" y="13.736">Display</tspan></text>
        <text transform="translate(225.645 60)"><tspan x="0" y="13.736">Display</tspan></text>
        <text transform="translate(411.903 108)"><tspan x="0" y="13.736">Display</tspan></text>
        <text transform="translate(222.097 108)"><tspan x="0" y="13.736">Video</tspan></text>
        <text transform="translate(16.7426 60)"><tspan x="0" y="13.736">CTV</tspan></text>
        <text transform="translate(16.7426 108)"><tspan x="0" y="13.736">CTV</tspan></text>
      </g>
      <g class="white huge">
        <text transform="translate(562.677 59)"><tspan x="0" y="15.07">18x</tspan></text>
        <text transform="translate(559.04 107)"><tspan x="0" y="15.07">28x</tspan></text>
      </g>
    </svg>
  {/if}
  
  <ViewSource id="ctv_conversion_charts">Internal data, Aug 2020.</ViewSource>
  <p class="takeaway accent"><strong>Key takeaway:</strong></p>
  <ul>
    <li>Network C drove the most lift in sales. Double down in the scatter market.</li>
  </ul>
</div>

<style>
  .title {
    margin: 0 0 40px;
  }
  .chart-header {
    color: #D7DADA;
    font-size: 0.875rem;
    font-weight: bold;
    margin: 2rem 0 0.5rem;
  }
  @media(max-width: 375px) {
    svg {
      width: 100%;
    }
  }
  svg text {
    font-family: inherit;
    white-space: pre;
    font-size: 14px;
    font-weight: 500;
  }
  .white {
    fill: white;
  }
  .gray {
    fill: var(--gray-link);
  }
  .gray-darker {
    fill: var(--gray-line);
  }
  .bold text {
    font-weight: bold;
  }
  .large text {
    font-size: 16px;
  }
  .larger text {
    font-size: 18px;
  }
  .huge text {
    font-size: 20px;
  }
  .red {
    fill: var(--verizon-red)
  }
  @media(min-width: 768px) {
    svg {
      width: 100%;
      height: auto;
    }
    .chart-header {
      margin-bottom: .75rem;
    }
  }
</style>